import axios from 'axios';
import { AsyncDispatch } from '../../../types/global';
import { getNonGwApiRoot } from '../../constants/ParamountReactConstants';

export const FETCH_ADMIN_USERS = 'FETCH_ADMIN_USERS';
export const FETCH_ADMIN_USERS_SILENT = 'FETCH_ADMIN_USERS_SILENT';
export const FETCH_USER_ACCOUNT_ASSIGNMENTS = 'FETCH_USER_ACCOUNT_ASSIGNMENTS';
export const UPDATE_USER_ACCOUNT_ASSIGNMENTS = 'UPDATE_USER_ACCOUNT_ASSIGNMENTS';
export const FETCH_AVAILABLE_ACCOUNTS = 'FETCH_AVAILABLE_ACCOUNTS';
export const UPDATE_USER_ROLES_PER_ACCOUNT = 'UPDATE_USER_ROLES_PER_ACCOUNT';
export const FETCH_ACCOUNT_USERS = 'FETCH_ACCOUNT_USERS';
export const SET_SELECTED_ADMIN_USER = 'SET_SELECTED_ADMIN_USER';

export const fetchAdminUsers = (search?: string, accountId?: number, silent?: boolean) => {
  const params: { search?: string; account_id?: number } = {};
  if (search) params.search = search;
  if (accountId) params.account_id = accountId;

  return {
    type: silent ? FETCH_ADMIN_USERS_SILENT : FETCH_ADMIN_USERS,
    payload: axios.get(`${getNonGwApiRoot()}/super-admin/users`, { params }),
  };
};

export const fetchUserAccountAssignments = (userId: number) => {
  return {
    type: FETCH_USER_ACCOUNT_ASSIGNMENTS,
    payload: axios.get(`${getNonGwApiRoot()}/users/${userId}/account_assignments`),
    meta: { userId },
  };
};

export const updateUserAccountAssignments = (userId: number, data: { account_ids: number[] }) => {
  return (dispatch: AsyncDispatch) => {
    return dispatch({
      type: UPDATE_USER_ACCOUNT_ASSIGNMENTS,
      payload: axios.post(
        `${getNonGwApiRoot()}/super-admin/users/${userId}/account_assignments`,
        data
      ),
    }).then(res => {
      // Use silent refetch to avoid unmounting the form
      dispatch(fetchAdminUsers(undefined, undefined, true));
      return res;
    });
  };
};

export const fetchAvailableAccounts = (excludeUserId?: number, search?: string) => {
  const params: { exclude_user_id?: number; search?: string } = {};
  if (excludeUserId) params.exclude_user_id = excludeUserId;
  if (search) params.search = search;

  return {
    type: FETCH_AVAILABLE_ACCOUNTS,
    payload: axios.get(`${getNonGwApiRoot()}/super-admin/accounts/available`, { params }),
  };
};

export const updateUserRolesPerAccount = (
  accountId: number,
  userId: number,
  data: { role_ids: number[] }
) => {
  return (dispatch: AsyncDispatch) => {
    return dispatch({
      type: UPDATE_USER_ROLES_PER_ACCOUNT,
      payload: axios.patch(
        `${getNonGwApiRoot()}/accounts/${accountId}/users/${userId}/roles`,
        data
      ),
    }).then(res => {
      dispatch(fetchUserAccountAssignments(userId));
      return res;
    });
  };
};

export const fetchAccountUsers = (
  accountId: number,
  includeInactive?: boolean,
  search?: string
) => {
  const params: { include_inactive?: boolean; search?: string } = {};
  if (includeInactive) params.include_inactive = includeInactive;
  if (search) params.search = search;

  return {
    type: FETCH_ACCOUNT_USERS,
    payload: axios.get(`${getNonGwApiRoot()}/accounts/${accountId}/users`, { params }),
    meta: { accountId },
  };
};

export const setSelectedAdminUser = (userId: number | null) => ({
  type: SET_SELECTED_ADMIN_USER,
  payload: userId,
});
